import { render, staticRenderFns } from "./CreateCollectionServiceModal.vue?vue&type=template&id=59b42180&scoped=true&"
import script from "./CreateCollectionServiceModal.vue?vue&type=script&lang=js&"
export * from "./CreateCollectionServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCollectionServiceModal.vue?vue&type=style&index=0&id=59b42180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b42180",
  null
  
)

export default component.exports